<template>
  <td>
    <div v-if="showNullHtml" v-html="nullHtml"></div>
    <div v-else>
      <a v-if="noRouter" :href="url">
        {{ source.name }}
      </a>
      <router-link v-else :to="url">
        {{ source.name }}
      </router-link>
      <div v-if="source.email">({{ source.email }})</div>
    </div>
  </td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";

export default {
    props: ['model', 'content'],
    computed: {
      source () {
        if(this.content !== ''){
          return this.content;
        }
        return this.model;
      },
      showNullHtml() {
        return !this.source;
      },
      nullHtml() {
        return defaultNullHtml();
      },
      noRouter() {
        return !this.$route;
      },
      url() {
        return `/moderator/detail/${this.source.id}`;
      }
    }
};
</script>
